export default {
  ZH_CN: {
    subject: {
      notSupport: "暂未开放"
    },
    menu: {
      use: "使用",
      publish: "发布",
      standard: "标准答案",
      edit: "编辑",
      delete: "删除",
      marking: "批改试卷",
      detailed: "详细记录",
      view: "查看"
    },
    difficulty: {
      1: "超简单难度",
      2: "简单难度",
      3: "正常难度",
      4: "一般困难",
      5: "非常困难"
    },
    type: {
      1: "TSA模拟练习",
      2: "DSE模拟练习",
      3: "普通练习模拟"
    },
    image: {
      insert: "插入图片",
      delete: "删除图片",
      moveUp: "上移",
      moveDown: "下移",
      select: "选择图片"
    },
    math: {
      insert: "插入公式"
    },
    paper: {
      title: "试卷",
      answer: "参考答案",
      analysis: "解析",
      explain: "解释",
      question: "题目",
      questionType: "题型",
      questionScore: "分值",
      questionOption: "选项",
      questionAnswer: "答案",
      addFromSys: "本地添加",
      questionAnalysis: "解析",
      questionNo: "题号",
      edit: "编辑模式",
      closeEdit: "关闭编辑模式",
      print: "打印",
      save: "保存",
      generating: "生成中",
      doNotSave: "不保存",
      saveOrNot: "是否保存",
      saveSuccess: "保存成功",
      saveFail: "保存失败",
      empty: "没有内容",
      createPaper: "创建试卷",
      inputPaperTitle: "请输入试卷标题",
      paperTitle: "请输入试卷标题",
      report: "试卷报告",
      notice: "请填写标题和上传封面图片",
      //123
      currentScore: "分",
      add: "扫描",
      ai: "AI评卷",
      score: "试卷总分",
      examScores: "试卷得分",
      checkScoreTips: "请点击[AI评卷]之后查看评分",
      noScore: "暂未评分",
      check: "查看",
      aiInprogress: "AI评卷中...",
      addImageFirst: "请先添加试卷",
      questionAnalysis2: "试题解析",
      batchGrading: "批量评卷",
      clickIndex: "点击错题序号，查看详细解析",
      wrongQuestion: "错误题",
      summary: "本次班级考试成绩总结",
      Accuracy: "学生作业正确率",
      achievementDistribution: "学生成绩分布",
      record: "试卷记录",
      paperName: "试卷名称",
      handwrittenAnswers: "手写答案",
      referenceAnswer: "参考答案",
      answerJudgment: "答案判断",
      keyPoints: "知识点",
      answerExplanation: "答案解析",
      scoring: "得分",
      totalScore: "总分"
    },
    class: {
      classMNG: "班级管理",
      class: "班级"
    },
    close: "关闭",
    open: "打开",

    upload: {
      noFile: "添加试卷文件",
      noFile2: "添加试卷标准解析文件",
      upload: "上传",
      uploadSuccess: "上传成功",
      uploadFail: "上传失败",
      uploadError: "上传错误",
      uploadCancel: "取消上传",
      uploadAbort: "中断上传",
      uploadRetry: "重试上传",
      uploadDelete: "删除文件",
      uploadPreview: "预览文件",
      uploadDownload: "下载文件",
      uploadMerge: "合并文件",
      uploadMergeSuccess: "合并成功",
      uploadTip: "拖动图片到这里<em>或者</em>点击上传"
    },
    editor: {
      bold: "加粗",
      italic: "斜体",
      underline: "下划线",
      strikeThrough: "删除线",
      foreColor: "文字颜色",
      backColor: "背景颜色",
      link: "超链接",
      unLink: "取消超链接",
      list: "列表",
      listOrdered: "有序列表",
      listUnordered: "无序列表",
      indent: "缩进",
      outdent: "取消缩进",
      insertMath: "插入公式",
      insertPinyin: "插入拼音"
    },
    scan: {
      start: "开始扫描",
      ready: "请将试卷放在扫描仪上准备扫描",
      unready: "未与设备连接",
      already: "已就绪",
      scanning: "已连接到 WebScan 服务。正在获取扫描仪列表...",
      notJson: "收到非JSON消息",
      findDevice: "找到扫描仪",
      unFind: "未找到任何扫描仪！",
      selectDevice: "已选择扫描仪:",
      selectParamsFail: "设置扫描参数失败",
      sending: "扫描参数设置成功。开始扫描...",
      sendSuccess: "扫描命令已发送，请等待扫描完成...",
      imgLoaded: "图像传输成功",
      connectClose: "与 WebScan 服务的连接已断开",
      connectError: "WebSocket 发生错误",
      connectFirst: "请先连接WebScan服务",
      setParams: "正在设置扫描参数...",
      scanningComplete: "",
      connectComplete: "已连接到 WebScan 服务"
    }
  },
  // 英文 (en_US)
  en_US: {
    subject: {
      notSupport: "Not open yet"
    },
    menu: {
      use: "Use",
      publish: "Publish",
      standard: "Standard answer",
      edit: "Edit",
      delete: "Delete",
      marking: "Marking",
      detailed: "Detailed",
      view: "View"
    },
    difficulty: {
      1: "Super Easy",
      2: "Easy",
      3: "Normal",
      4: "Moderately Difficult",
      5: "Very Difficult"
    },
    type: {
      1: "TSA Practice Simulation",
      2: "DSE Practice Simulation",
      3: "General Practice Simulation"
    },
    image: {
      insert: "Insert Image",
      delete: "Delete Image",
      moveUp: "Move Up",
      moveDown: "Move Down",
      select: "Select Image"
    },
    math: {
      insert: "Insert Formula"
    },
    paper: {
      title: "Exam Paper",
      answer: "Reference Answers",
      analysis: "Analysis",
      explain: "Explanation",
      question: "Question",
      questionType: "Question Type",
      questionScore: "Score",
      questionOption: "Options",
      questionAnswer: "Answer",
      questionAnalysis: "Analysis",
      questionNo: "Question No.",
      edit: "Edit Mode",
      closeEdit: "Close Edit Mode",
      print: "Print",
      save: "Save",
      generating: "Generating",
      doNotSave: "Don't Save",
      saveOrNot: "Save or Not?",
      saveSuccess: "Saved Successfully",
      saveFail: "Save Failed",
      empty: "No Content",
      createPaper: "Create Exam Paper",
      inputPaperTitle: "Please Enter Exam Paper Title",
      report: "Exam Report",
      editTitle: "Edit Title and Cover",
      add: "Add it from the scanner",
      addFromSys: "Add from disk",
      ai: "AI Grading",
      currentScore: " Points",
      score: "Total Score",
      checkScoreTips: "Please click [AI Grading] to view the score",
      noScore: "Not Yet Graded",
      check: "View",
      batchGrading: "Batch scoring",
      examScores: "Test paper scores",
      notice: "Please fill in the title and upload a cover image",
      aiInprogress: "AI Grading in Progress...",
      addImageFirst: "Please Add Exam Paper First",
      questionAnalysis2: "Analysis",
      clickIndex: "Click on the wrong question number to view detailed analysis",
      wrongQuestion: "Wrong Questions",
      summary: "Summary of the class exam results for this year",
      Accuracy: "Students' homework accuracy rate",
      achievementDistribution: "Student achievement distribution",
      record: "Test paper records",
      paperName: "Title of the exam paper",
      handwrittenAnswers: "Handwritten answers",
      referenceAnswer: "Reference answer",
      answerJudgment: "Judgment",
      keyPoints: "Key points",
      answerExplanation: "Explanation",
      scoring: "Scoring",
      totalScore: "Overall score"
    },
    class: {
      classMNG: "Class Management",
      class: "Class"
    },
    close: "Close",
    open: "Open",

    upload: {
      noFile: "Add test paper files",
      noFile2: "Add the parsing file for test paper tiles",
      upload: "Upload",
      uploadSuccess: "Upload Successful",
      uploadFail: "Upload Failed",
      uploadError: "Upload Error",
      uploadCancel: "Cancel Upload",
      uploadAbort: "Abort Upload",
      uploadRetry: "Retry Upload",
      uploadDelete: "Delete File",
      uploadPreview: "Preview File",
      uploadDownload: "Download File",
      uploadMerge: "Merge Files",
      uploadMergeSuccess: "Merge Successful",
      uploadTip: "Drag images here <em>or</em> click to upload"
    },
    editor: {
      bold: "Bold",
      italic: "Italic",
      underline: "Underline",
      strikeThrough: "Strikethrough",
      foreColor: "Text Color",
      backColor: "Background Color",
      link: "Hyperlink",
      unLink: "Remove Hyperlink",
      list: "List",
      listOrdered: "Ordered List",
      listUnordered: "Unordered List",
      indent: "Indent",
      outdent: "Outdent",
      insertMath: "Insert the formula",
      insertPinyin: "Insert pinyin"
    },
    scan: {
      start: "Start scanning",
      ready: "Place the test paper on the scanner to prepare for scanning",
      unready: "Not connected to the device",
      already: "Ready",
      scanning: "Connected to the WebScan service. Get the scanner list...",
      notJson: "Received a non-JSON message",
      findDevice: "Find the scanner",
      unFind: "No scanners found！",
      selectDevice: "Scanner selected:",
      selectParamsFail: "Failed to set scan parameters",
      sending: "The scan parameter settings were successful. Start scanning...",
      sendSuccess: "The scan command has been sent; please wait for the scan to complete...",
      imgLoaded: "Image transmission successful",
      connectClose: "The connection to the WebScan service has been disconnected",
      connectError: "An error occurred with WebSocket",
      connectFirst: "Please connect to the WebScan service first",
      setParams: "Set the scan parameters...",
      scanningComplete: "",
      connectComplete: "Connected to the WebScan service"
    }
  },

  // 中文繁体 (zh_HK)
  zh_HK: {
    subject: {
      notSupport: "暫未開放"
    },
    menu: {
      use: "使用",
      publish: "發佈",
      standard: "標準答案",
      edit: "編輯",
      delete: "刪除",
      marking: "批改試卷",
      detailed: "詳細記錄",
      view: "查看"
    },
    difficulty: {
      1: "超簡單難度",
      2: "簡單難度",
      3: "正常難度",
      4: "一般困難",
      5: "非常困難"
    },
    type: {
      1: "TSA模擬練習",
      2: "DSE模擬練習",
      3: "普通練習模擬"
    },
    image: {
      insert: "插入圖片",
      delete: "刪除圖片",
      moveUp: "上移",
      moveDown: "下移",
      select: "選擇圖片"
    },
    math: {
      insert: "插入公式"
    },
    paper: {
      title: "試卷",
      answer: "參考答案",
      analysis: "解析",
      explain: "解釋",
      question: "題目",
      questionType: "題型",
      questionScore: "分值",
      questionOption: "選項",
      questionAnswer: "答案",
      questionAnalysis: "解析",
      questionNo: "題號",
      edit: "編輯模式",
      closeEdit: "關閉編輯模式",
      print: "列印",
      save: "儲存",
      generating: "生成中",
      doNotSave: "不儲存",
      saveOrNot: "是否儲存",
      saveSuccess: "儲存成功",
      saveFail: "儲存失敗",
      empty: "沒有內容",
      examScores: "考試分數",
      createPaper: "創建試卷",
      inputPaperTitle: "請輸入試卷標題",
      report: "試卷報告",
      editTitle: "編輯標題和封面",
      notice: "請填寫標題並上傳封面圖片",
      add: "掃描",
      addFromSys: "本地添加",
      ai: "AI評卷",
      score: "試卷總分",
      checkScoreTips: "請點擊[AI評卷]之後查看評分",
      noScore: "暫未評分",
      currentScore: "分",
      check: "查看",
      batchGrading: "批量評卷",
      aiInprogress: "AI評卷中...",
      addImageFirst: "請先新增試卷",
      questionAnalysis2: "試題解析",
      clickIndex: "點擊錯題序號，查看詳細解析",
      wrongQuestion: "錯誤題",
      summary: "本次班級考試成績總結",
      Accuracy: "學生作業正確率",
      achievementDistribution: "學生成績分佈",
      record: "試卷記錄",
      paperName: "試卷名稱",
      handwrittenAnswers: "手寫答案",
      referenceAnswer: "參考答案",
      answerJudgment: "答案判斷",
      keyPoints: "知識點",
      answerExplanation: "答案解析",
      scoring: "得分",
      totalScore: "總分"
    },
    class: {
      classMNG: "班級管理",
      class: "班級"
    },
    close: "關閉",
    open: "開啟",

    upload: {
      noFile: "添加試卷文件",
      noFile2: "添加試卷標準解析文件",
      upload: "上傳",
      uploadSuccess: "上傳成功",
      uploadFail: "上傳失敗",
      uploadError: "上傳錯誤",
      uploadCancel: "取消上傳",
      uploadAbort: "中斷上傳",
      uploadRetry: "重試上傳",
      uploadDelete: "刪除檔案",
      uploadPreview: "預覽檔案",
      uploadDownload: "下載檔案",
      uploadMerge: "合併檔案",
      uploadMergeSuccess: "合併成功",
      uploadTip: "拖動圖片到這裡<em>或者</em>點擊上傳"
    },
    editor: {
      bold: "粗體",
      italic: "斜體",
      underline: "底線",
      strikeThrough: "刪除線",
      foreColor: "文字顏色",
      backColor: "背景顏色",
      link: "超連結",
      unLink: "取消超連結",
      list: "列表",
      listOrdered: "有序列表",
      listUnordered: "無序列表",
      indent: "縮排",
      outdent: "取消縮排",
      insertMath: "插入公式",
      insertPinyin: "插入拼音"
    },
    scan: {
      start: "開始掃描",
      ready: "請將試卷放在掃描器上準備掃描",
      unready: "未與設備連接",
      already: "已就緒",
      scanning: "已連接到 WebScan 服務。 取得掃描器清單...",
      notJson: "收到非JSON消息",
      findDevice: "找到掃描器",
      unFind: "未找到任何掃描器！",
      selectDevice: "已選擇掃描器:",
      selectParamsFail: "設置掃描參數失敗",
      sending: "掃描參數設置成功。 開始掃描...",
      sendSuccess: "掃描命令已發送，請等待掃描完成...",
      imgLoaded: "圖像傳輸成功",
      connectClose: "與WebScan服務的連接已斷開",
      connectError: "WebSocket發生錯誤",
      connectFirst: "請先連接WebScan服務",
      setParams: "設定掃描參數...",
      scanningComplete: "",
      connectComplete: "已連接到WebScan服務"
    }
  },

  // 西班牙文 (ES)
  ES: {
    subject: {
      notSupport: "Aún no está abierto"
    },
    menu: {
      use: "Uso",
      publish: "Lanzamiento",
      standard: "Respuesta estándar",
      edit: "Edición",
      delete: "Borrar",
      marking: "Calificación de exámenes",
      detailed: "Registros detallados",
      view: "Vista"
    },
    difficulty: {
      1: "Dificultad muy fácil",
      2: "Dificultad fácil",
      3: "Dificultad normal",
      4: "Dificultad moderadamente difícil",
      5: "Es extremadamente difícil"
    },
    type: {
      1: "Simulación de práctica TSA",
      2: "Simulación de práctica DSE",
      3: "Simulación de práctica general"
    },
    image: {
      insert: "Insertar imagen",
      delete: "Eliminar imagen",
      moveUp: "Mover arriba",
      moveDown: "Mover abajo",
      select: "Seleccionar imagen"
    },
    math: {
      insert: "Insertar fórmula"
    },
    paper: {
      title: "Examen",
      answer: "Respuestas de referencia",
      analysis: "Análisis",
      explain: "Explicación",
      question: "Pregunta",
      questionType: "Tipo de pregunta",
      questionScore: "Puntuación",
      questionOption: "Opciones",
      questionAnswer: "Respuesta",
      questionAnalysis: "Análisis",
      questionNo: "Nº de pregunta",
      edit: "Modo edición",
      closeEdit: "Cerrar modo edición",
      examScores: "Resultados de los exámenes",
      print: "Imprimir",
      save: "Guardar",
      currentScore: "Puntos",
      batchGrading: "Clasificación por lotes",
      generating: "Generando",
      doNotSave: "No guardar",
      saveOrNot: "¿Guardar o no?",
      notice: "Por favor, complete el título y suba la imagen de portada",
      saveSuccess: "Guardado exitosamente",
      saveFail: "Error al guardar",
      empty: "Sin contenido",
      createPaper: "Crear examen",
      inputPaperTitle: "Por favor, introduzca el título del examen",
      report: "Informe del examen",
      editTitle: "Editar título y portada",
      add: "Añadir desde el escáner",
      addFromSys: "Añadir desde el disco",
      ai: "Calificación por IA",
      score: "Puntuación total",
      checkScoreTips: "Por favor, haga clic en [Calificación por IA] para ver la puntuación",
      noScore: "Aún no calificado",
      check: "Ver",
      aiInprogress: "Calificación por IA en progreso...",
      addImageFirst: "Por favor, añada primero el examen",
      questionAnalysis2: "Análisis",
      clickIndex: "Haga clic en el número de pregunta incorrecta para ver el análisis detallado",
      wrongQuestion: "Preguntas incorrectas",
      summary: "Resumen de los resultados del examen de clase",
      Accuracy: "Tasa de precisión de las asignaciones de los estudiantes",
      achievementDistribution: "Distribución de las calificaciones de los estudiantes",
      record: "Registros de exámenes",
      paperName: "Título del examen",
      handwrittenAnswers: "Respuestas manuscritas",
      referenceAnswer: "Respuesta de referencia",
      answerJudgment: "Sentencia",
      keyPoints: "Puntos clave",
      answerExplanation: "Explicación",
      scoring: "Puntuación",
      totalScore: "Puntuación global"
    },
    class: {
      classMNG: "Gestión de clase",
      class: "Clase"
    },
    close: "Cerrar",
    open: "Abrir",

    upload: {
      noFile: "Añadir archivos de papel de prueba",
      noFile2: "Añadir archivos estándar analizados para el examen",
      upload: "Subir",
      uploadSuccess: "Subida exitosa",
      uploadFail: "Error en la subida",
      uploadError: "Error de subida",
      uploadCancel: "Cancelar subida",
      uploadAbort: "Interrumpir subida",
      uploadRetry: "Reintentar subida",
      uploadDelete: "Eliminar archivo",
      uploadPreview: "Vista previa del archivo",
      uploadDownload: "Descargar archivo",
      uploadMerge: "Combinar archivos",
      uploadMergeSuccess: "Combinación exitosa",
      uploadTip: "Arrastre imágenes aquí <em>o</em> haga clic para subir"
    },
    editor: {
      bold: "Negrita",
      italic: "Cursiva",
      underline: "Subrayado",
      strikeThrough: "Tachado",
      foreColor: "Color del texto",
      backColor: "Color de fondo",
      link: "Hipervínculo",
      unLink: "Eliminar hipervínculo",
      list: "Lista",
      listOrdered: "Lista ordenada",
      listUnordered: "Lista desordenada",
      indent: "Sangría",
      outdent: "Reducir sangría",
      insertMath: "Insert the formula",
      insertPinyin: "Insertar pinyin"
    },
    scan: {
      start: "Empieza a escanear",
      ready: "Coloca el papel de prueba en el escáner para prepararte para el escaneo",
      unready: "No conectado al dispositivo",
      already: "Listo",
      scanning: "Conectado al servicio WebScan. Consigue la lista de escáneres...",
      notJson: "Recibido un mensaje no JSON",
      findDevice: "Encuentra el escáner",
      unFind: "No se han encontrado escáneres！",
      selectDevice: "Escáner seleccionado:",
      selectParamsFail: "No se han configurado los parámetros de escaneo",
      sending: "Los parámetros de escaneo fueron correctos. Empieza a escanear...",
      sendSuccess:
        "El comando de escaneo ha sido enviado; Por favor, esperad a que termine el escaneo...",
      imgLoaded: "Transmisión de imagen exitosa",
      connectClose: "La conexión al servicio WebScan se ha desconectado",
      connectError: "Ocurrió un error con WebSocket",
      connectFirst: "Por favor, conéctate primero con el servicio WebScan",
      setParams: "Establece los parámetros de escaneo...",
      scanningComplete: "",
      connectComplete: "Conectado al servicio WebScan"
    }
  }
};
